<template>
  <div class="event-report">
    <Card :dis-hover="true" :bordered="false">
      <Button type="primary" @click="gotoEventInfo">事件上报</Button>
    </Card>
    <!--    <Card :dis-hover="true" :bordered="false" :padding="0">-->
    <!--      <el-descriptions :column="1" border size="small">-->
    <!--        <el-descriptions-item label="队伍类型" :label-style="{'text-align': 'right', 'width':'120px'}">-->
    <!--          &lt;!&ndash;          <TagSelect v-model="teamType" @on-change="tagChange">&ndash;&gt;-->
    <!--          &lt;!&ndash;            <TagSelectOption name="1">政府队伍</TagSelectOption>&ndash;&gt;-->
    <!--          &lt;!&ndash;            <TagSelectOption name="2">企业队伍</TagSelectOption>&ndash;&gt;-->
    <!--          &lt;!&ndash;            <TagSelectOption name="3">社会队伍</TagSelectOption>&ndash;&gt;-->
    <!--          &lt;!&ndash;          </TagSelect>&ndash;&gt;-->
    <!--          <RadioGroup size="small" v-model="teamType" type="button" @on-change="tagChange">-->
    <!--            <Radio :label="0">全部</Radio>-->
    <!--            <Radio :label="1">政府队伍</Radio>-->
    <!--            <Radio :label="2">企业队伍</Radio>-->
    <!--            <Radio :label="3">社会队伍</Radio>-->
    <!--          </RadioGroup>-->
    <!--        </el-descriptions-item>-->
    <!--        <el-descriptions-item label="行政区划" :label-style="{'text-align': 'right'}">-->
    <!--          <Row>-->
    <!--            <Col :span="6">-->
    <!--              <span>区县：</span>-->
    <!--              <Select transfer v-model="country" clearable style="width:200px">-->
    <!--                <Option v-for="(item) in countryList" :value="item.id">{{item.name}}</Option>-->
    <!--              </Select>-->
    <!--            </Col>-->
    <!--            <Col :span="7">-->
    <!--              <span>队伍名称：</span>-->
    <!--              <Input v-model="teamName" clearable style="width:200px"></Input>-->
    <!--            </Col>-->
    <!--            <Col :span="4">-->
    <!--              <Button type="primary" @click="getEmergencyTeams">查询</Button>-->
    <!--            </Col>-->
    <!--          </Row>-->
    <!--        </el-descriptions-item>-->
    <!--      </el-descriptions>-->
    <!--    </Card>-->
    <Table
        :loading="dataLoading"
        :columns="columns"
        :data="data"
        :border="false"
        :stripe="false"
        :highlight-current-row="true"
        style="margin-top: 10px"
    >
      <template #action="{ row, index }">
        <el-button size="small" type="text" @click="editTeam(row)">编辑</el-button>
        <el-button size="small" type="text" @click="deleteTeam(row)">删除</el-button>
      </template>
    </Table>
    <Page style="text-align: right;margin-top: 10px"
          show-sizer
          show-total
          transfer
          :total="dataTotal"
          :page-size="pageSize"
          :page-size-opts="pageSizeOpts"
          :current-page="currentPage"
          @on-change="pageChange"
          @on-page-size-change="pageSizeChange"
    ></Page>

  </div>
</template>

<script>
export default {
  name: "eventReport",
  data(){
    return {
      dataLoading: false,
      dataTotal: 0,
      columns: [
        {
          title: '名称',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'left'
              }
            }, params.row.emergencyTeam.name)
          }
        },
        {
          width: '200',
          title: '操作',
          // fixed: 'right',
          align: 'center',
          slot: 'action',
        }
      ],
      data: [],
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      currentPage: 1
    }
  },
  methods:{
    gotoEventInfo(){
      this.$router.push({name: 'eventInfo'})
    },
    pageChange(page) {
      this.currentPage = page
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
    },
  }
}
</script>

<style scoped>

</style>
